// extracted by mini-css-extract-plugin
export default {"sn":"DeviceUpdate_sn__hC1l0"};